export default __webpack_public_path__ + "static/media/imc-2024-inner.12a9e912.png";